import React from 'react'
import Constants from 'EurestoFonction/Constants'

import Formulaire from 'Components/Formulaire'
import Template from './form'

const columns = [{
  header: 'Id',
  id: 'id',
  show: false,
}, {
  id: 'libelle',
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Motif d\'archivage')}</strong>,
  type: 'string',
}, {
  header: EurestoI18n.t('commun:Abrégé'),
  id: 'abrege',
  type: 'string',
}]

export default React.memo(props => <Formulaire defaultObject={{
  abrege: undefined, libelle: undefined, actif: 1
}} title={EurestoI18n.t('commun:Motif d\'archivage')} columnSearch={'id'} form={<Template/>} path={Constants.module.COMMUN} module={Constants.module.CRM} requete={Constants.donnee.type_archivage} columns={columns}/>)


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/CRM/MotifArchivage/index.js